export default __webpack_public_path__ + "static/media/personal-service.6d2c9b4a.svg";